




import { Component, Vue, Prop } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    faClinicMedical,
    faHome,
    faUserMd,
    faUserFriends,
    faCalendarAlt,
    faFolderPlus,
    faStethoscope,
    faAddressBook,
    faMoneyCheckAlt,
    faHistory,
    faHandshake,
    faCalculator,
} from '@fortawesome/free-solid-svg-icons';

@Component({
    name: 'IconMenu',
    components: {
        FontAwesomeIcon,
    },
})
export default class IconFont extends Vue {
    @Prop({ required: false }) readonly icon?: string;
    @Prop({ required: false }) readonly size?: string;

    get menuIcon() {
        switch (this.icon) {
            case faCalculator.iconName:
                return faCalculator;
            case faClinicMedical.iconName:
                return faClinicMedical;
            case faUserMd.iconName:
                return faUserMd;
            case faCalendarAlt.iconName:
                return faCalendarAlt;
            case faFolderPlus.iconName:
                return faFolderPlus;
            case faStethoscope.iconName:
                return faStethoscope;
            case faMoneyCheckAlt.iconName:
                return faMoneyCheckAlt;
            case faUserFriends.iconName:
                return faUserFriends;
            case faAddressBook.iconName:
                return faAddressBook;
            case faHistory.iconName:
                return faHistory;
            case faHandshake.iconName:
                return faHandshake;
            default:
                return faHome;
        }
    }
}
